// green gradient
export const GreenGrad = (svg: any) => {
  const greenGrad = svg.append('defs')
  const svgGreenGrad = greenGrad
    .append('linearGradient')
    .attr('id', 'greenGrad')
    .attr('x1', '0%')
    .attr('y2', '0%')
    .attr('x2', '0%')
    .attr('y2', '100%')
  svgGreenGrad
    .append('stop')
    .attr('stop-color', 'rgba(114, 173, 39, 0)')
    .attr('offset', '10.22%')
  svgGreenGrad
    .append('stop')
    .attr('stop-color', 'rgba(94, 145, 30, 0.6)')
    .attr('offset', '45.28%')
  svgGreenGrad
    .append('stop')
    .attr('stop-color', '#5C8D1D')
    .attr('offset', '90.66%')
}

// gray gradient
export const GrayGrad = (svg: any) => {
  const grayGrad = svg.append('defs')
  const svgGrayGrad = grayGrad
    .append('linearGradient')
    .attr('id', 'grayGrad')
    .attr('x1', '0%')
    .attr('y2', '0%')
    .attr('x2', '0%')
    .attr('y2', '100%')
  svgGrayGrad
    .append('stop')
    .attr('stop-color', 'rgba(57, 58, 75, 0)')
    .attr('offset', '10.22%')
  svgGrayGrad
    .append('stop')
    .attr('stop-color', '#393A4B')
    .attr('offset', '45.28%')
  svgGrayGrad
    .append('stop')
    .attr('stop-color', '#393A4B')
    .attr('offset', '90.66%')
}

// blue Gradient
export const BlueGrad = (svg: any, animate: any) => {
  const blueGrad = svg.append('defs')
  const svgBlueGradient = blueGrad
    .append('linearGradient')
    .attr('id', 'blueGrad')
    .attr('x1', '0%')
    .attr('y2', '0%')
    .attr('x2', '0%')
    .attr('y2', '100%')
  svgBlueGradient
    .append('stop')
    .attr('stop-color', 'rgba(52, 52, 64, 0)')
    .attr('offset', 0)
  svgBlueGradient
    .append('stop')
    .attr('stop-color', 'rgba(52, 52, 64, 0.65)')
    .attr('offset', '11.98%')
  svgBlueGradient
    .append('stop')
    .attr('stop-color', '#2141C1')
    .attr('offset', '44.79%')
  svgBlueGradient
    .append('stop')
    .attr('stop-color', ' #30375C')
    .attr('offset', '77.6%')
  svgBlueGradient
    .append('stop')
    .attr('stop-color', '#343440')
    .attr('offset', '100%')

  animate &&
    svgBlueGradient
      .append('animate')
      .attr('attributeName', 'y2')
      .attr('values', '90%;420%')
      .attr('dur', '2s')
      .attr('repeatCount', 'indefinite')
}

// horizontal blue Gradient
export const BlueGradHorizontal = (svg: any, animate: any) => {
  const blueGradHorizontal = svg.append('defs')
  const svgBlueGradientHorizontal = blueGradHorizontal
    .append('linearGradient')
    .attr('id', 'blueGradHorizontal')
    .attr('x1', '0%')
    .attr('y2', '0%')
    .attr('x2', '100%')
    .attr('y2', '0%')
  svgBlueGradientHorizontal
    .append('stop')
    .attr('stop-color', 'rgba(52, 52, 64, 0)')
    .attr('offset', 0)
  svgBlueGradientHorizontal
    .append('stop')
    .attr('stop-color', 'rgba(52, 52, 64, 0.65)')
    .attr('offset', '11.98%')
  svgBlueGradientHorizontal
    .append('stop')
    .attr('stop-color', ' #2141C1')
    .attr('offset', '50.52%')
  svgBlueGradientHorizontal
    .append('stop')
    .attr('stop-color', ' rgba(52, 52, 64, 0.65)')
    .attr('offset', '87.5%')
  svgBlueGradientHorizontal
    .append('stop')
    .attr('stop-color', 'rgba(52, 52, 64, 0)')
    .attr('offset', '100%')

  animate &&
    svgBlueGradientHorizontal
      .append('animate')
      .attr('attributeName', 'x2')
      .attr('values', '0%;500%')
      .attr('dur', '4s')
      .attr('repeatCount', 'indefinite')
}

// red Gradient
export const RedGrad = (svg: any, animate: any) => {
  const redGrad = svg.append('defs')
  const svgRedGradient = redGrad
    .append('linearGradient')
    .attr('id', 'redGrad')
    .attr('x1', '0%')
    .attr('y2', '0%')
    .attr('x2', '0%')
    .attr('y2', '100%')
  svgRedGradient
    .append('stop')
    .attr('stop-color', 'rgba(52, 52, 64, 0.65)')
    .attr('offset', 0)
  svgRedGradient
    .append('stop')
    .attr('stop-color', 'rgba(52, 52, 64, 0.65)')
    .attr('offset', '11.98%')
  svgRedGradient
    .append('stop')
    .attr('stop-color', '#DD2E2E')
    .attr('offset', '44.79%')
  svgRedGradient
    .append('stop')
    .attr('stop-color', '#343440')
    .attr('offset', '77.6%')
  svgRedGradient
    .append('stop')
    .attr('stop-color', 'rgba(52, 52, 64, 0)')
    .attr('offset', '100%')

  animate &&
    svgRedGradient
      .append('animate')
      .attr('attributeName', 'y1')
      .attr('values', '30%;-300%')
      .attr('dur', '2s')
      .attr('repeatCount', 'indefinite')
}

// horizontal red Gradient
export const RedGradHorizontal = (svg: any, animate: any) => {
  const redGradHorizontal = svg.append('defs')
  const svgRedGradientHorizontal = redGradHorizontal
    .append('linearGradient')
    .attr('id', 'redGradHorizontal')
    .attr('x1', '0%')
    .attr('y2', '0%')
    .attr('x2', '100%')
    .attr('y2', '0%')
  svgRedGradientHorizontal
    .append('stop')
    .attr('stop-color', 'rgba(52, 52, 64, 0)')
    .attr('offset', 0)
  svgRedGradientHorizontal
    .append('stop')
    .attr('stop-color', 'rgba(52, 52, 64, 0.65)')
    .attr('offset', '11.98%')
  svgRedGradientHorizontal
    .append('stop')
    .attr('stop-color', ' #DD2E2E')
    .attr('offset', '50.52%')
  svgRedGradientHorizontal
    .append('stop')
    .attr('stop-color', ' rgba(52, 52, 64, 0.65)')
    .attr('offset', '87.5%')
  svgRedGradientHorizontal
    .append('stop')
    .attr('stop-color', 'rgba(52, 52, 64, 0)')
    .attr('offset', '100%')

  animate &&
    svgRedGradientHorizontal
      .append('animate')
      .attr('attributeName', 'x2')
      .attr('values', '0%;500%')
      .attr('dur', '4s')
      .attr('repeatCount', 'indefinite')
}

// middle line gradient
export const MiddleLineGradient = (svg: any) => {
  const svgDefs = svg.append('defs')
  const svgGradient = svgDefs
    .append('linearGradient')
    .attr('id', 'gradient')
    .attr('x1', '0%')
    .attr('y2', '0%')
    .attr('x2', '100%')
    .attr('y2', '0%')
  svgGradient
    .append('stop')
    .attr('stop-color', 'rgba(185, 185, 204, 0)')
    .attr('offset', 0)
  svgGradient
    .append('stop')
    .attr('stop-color', 'rgba(185, 185, 204, 0.23)')
    .attr('offset', '17.83%')
  svgGradient
    .append('stop')
    .attr('stop-color', '#B9B9CC')
    .attr('offset', '50.51%')
  svgGradient
    .append('stop')
    .attr('stop-color', 'rgba(185, 185, 204, 0.23)')
    .attr('offset', '75.27%')
  svgGradient
    .append('stop')
    .attr('stop-color', 'rgba(185, 185, 204, 0)')
    .attr('offset', '199.04%')
}
